function getUnreadMessagesCount(state) {
	return state.inbox.unreadMessagesCount;
}

function hasEmptyInbox(state) {
	return !state.inbox.hasAnyMessages;
}

function getLastUpdate(state) {
	return state.inbox.lastUpdate;
}

function getUnreadMessagesIds(state) {
	return state.inbox.unreadMessagesIds;
}

function getLastMsgId(state) {
	return state.inbox.lastMsgId;
}

export {
	hasEmptyInbox,
	getLastUpdate,
	getUnreadMessagesCount,
	getUnreadMessagesIds,
	getLastMsgId
};
